import React from 'react';
import '../../css/components/Auth/AuthWelcome.css';

const AuthWelcome = ({ 
  title, 
  subtitle, 
  showSignupLink = false,
  showProgress = false,
  currentStep = 1,
  totalSteps = 5
}) => {
  const progressPercentage = showProgress ? (currentStep / totalSteps) * 100 : 0;

  return (
    <div className="auth-welcome-content">
      <h1 className="auth-main-heading">{title}</h1>
      <p className="auth-sub-heading">{subtitle}</p>
      
      {showProgress && (
        <div className="auth-progress-container">
          <div className="auth-progress-bar">
            <div 
              className="auth-progress-fill" 
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
          <p className="auth-progress-text">Step {currentStep} of {totalSteps}</p>
        </div>
              )}
        
        {showSignupLink && (
          <p className="auth-signup-prompt">
            Don't have an account? <a href="/signup" className="auth-signup-link">Sign up</a>
          </p>
        )}
      </div>
  );
};

export default AuthWelcome; 